import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";

function BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/BatchOut" ? (
        <div>
          <span className="breadcrumb-not-active ">BatchOut </span>
        </div>
      ) : vPathName === "/BatchOutDetail" ? (
        <div className={"d-flex align-items-center"}>
          <Link
            to="/BatchOut"
            state={location}
            className={"breadcrumb-active mr-2"}
          >
            BatchOut
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span className="breadcrumb-not-active">BatchOutDetail </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default BreadCrumbs;
